import { Component, Input } from '@angular/core';
import { OriginalFare, RefundFare } from 'src/app/core/models/cancellation.model';

@Component({
  selector: 'app-refund-taxes',
  templateUrl: './refund-taxes.component.html',
})
export class RefundTaxesComponent  {
  @Input() refundFare: RefundFare;
  @Input() originalFare: OriginalFare;

}
